import request from "@/utlis/request";

//  新闻列表
export function getNewsListApi(params) {
  return request({
    url: "/news/admin/list",
    method: "get",
    params,
  });
}

//  材料列表
export function getMaterialListApi(params) {
  return request({
    url: "/material/admin/list",
    method: "get",
    params,
  });
}

//  登录
export function loginApi(data) {
  return request({
    url: "/web/user/login",
    method: "post",
    data,
  });
}

//  注册
export function registerApi(data) {
  return request({
    url: "/web/user/register",
    method: "post",
    data,
  });
}

//  修改用户信息
export function updateUserInfoApi(data) {
  return request({
    url: "/web/user/update",
    method: "post",
    data,
  });
}

// 修改用户密码
export function updatePasswordApi(data) {
  return request({
    url: "/web/user/update/password",
    method: "post",
    data,
  });
}

//  城市列表
export function getCityListApi(params) {
  return request({
    url: "/city/admin/info",
    method: "get",
    params,
  });
}

//  业务列表
export function getBusinessListApi(params) {
  return request({
    url: "/web/business/list",
    method: "get",
    params,
  });
}

//  创建订单
export function createOrderApi(data) {
  return request({
    url: "/order/create",
    method: "post",
    data,
  });
}

//  订单列表
export function getOrderListApi() {
  return request({
    url: "/order/list",
    method: "get",
  });
}

// 获取新闻详情
export function getNewsDetailApi(id) {
  return request({
    url: `/news/detail/${id}`,
    method: "get"
  });
}
